// OtterBonk's game data (data.js) in the page's language: data.js keeps each entry's words in 简体中文 with an `en`
// next to them (inLang); the enemies' and bosses' names are the catalogs' (ob.enemy.<key>, ob.boss.<key>). The run's
// page, the welcome page, the 大百科 and the 新手教程 word data through here, so they follow 设置 → 语言.
import { lang, t, has } from '/i18n.js';
import { inLang, cardInfo, statLine, statText, teamHint, ENEMIES, BOSSES } from './data.js';

/** A data.js entry (a class, weapon, passive, route, stat, item, prop, map, region) in the page's language. */
export const L = (o) => inLang(o, lang);
/** data.js cardInfo in the page's language. */
export const cardText = (card, lv) => cardInfo(card, lv, lang);
/** "伤害 +10%" / "Damage +10%". */
export const statLineL = (k, v) => statLine(k, v, lang);
export { statText };
/** The room card's hint for these classes (data.js teamHint), or null. */
export const hintText = (classes) => teamHint(classes, lang);
/** An enemy's name (ENEMIES[k] or the entry itself). */
export const enemyName = (e) => { const d = typeof e === 'number' ? ENEMIES[e] : e; return !d ? '' : has(`ob.enemy.${d.key}`) ? t(`ob.enemy.${d.key}`) : (d.name ?? ''); };
/** A boss's name (BOSSES[k] or the entry itself). */
export const bossName = (b) => { const B = typeof b === 'number' ? BOSSES[b] : b; return !B ? '' : has(`ob.boss.${B.key}`) ? t(`ob.boss.${B.key}`) : (B.name ?? ''); };
